import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, showMessageToastCustom } from '../../../utils/util';
import ListPagination from '../../../components/UI/ListPaginationUl';
import NotificationListItem from './NotificationListItem';
import Breadcrumbs from '../../../components/UI/Breadcrumbs';
import { ENUMS } from '../../../utils/constants';
import MessageService from '../../../services/MessageService';

const ListNotifications = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if (props.messages?.items?.length > 0) {
            if (messages.length > 0 && currentPage === 0) {
                setMessages(props.messages.items);
            } else {
                setMessages((prevState) => ([...prevState, ...props.messages.items]));
            }
        } else {
            setMessages([]);
        }
        // eslint-disable-next-line
    }, [props?.messages?.items]);

    useEffect(() => {
        props.getNotifications(props.user.vision, { read: false }, {
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectItemChange = (message) => {
        props.notificationUpdate(message, (response) => {
            if (!response) {
                showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
        });
    };

    return (
        <div>
            <Breadcrumbs id="notificationList" title={{ icon: "mdi mdi-bell-ring-outline", label: translate('notifications.title', 'general') }} subtitles={[]} />
            {messages ? (
                <div className="container-fluid" style={{ marginTop: '15px' }}>
                    <div id="ListItemsMap" className="container-fluid">
                        <ListPagination
                            page={props.messages?.totalPages}
                            current={{ currentPage, setCurrentPage }}
                            data={
                                messages.map((item, index) => {
                                    return (
                                        <NotificationListItem
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={`oi-${index}`}
                                            data={item}
                                            onSelectChange={() => onSelectItemChange(item)}
                                        />
                                    );
                                })
                            }
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        messages: state.messageReducer.messages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNotifications: (vision, filter, pagination) => {
            dispatch(MessageService.GetNotifications(vision, filter, pagination));
        },
        notificationUpdate: (notification, callback) => {
            dispatch(MessageService.PutNotification(notification, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListNotifications)));
